





import { defineComponent, onMounted, onUnmounted, ref } from '@vue/composition-api';
import 'driver.js/dist/driver.min.css';
import { isShowNewGuide, abtInit } from '@/business/home-newguide-abtest';
import { useDriver } from './use-driver';
import { biBrow } from '@tencent/fit-bi-sdk';
import { url } from '@tencent/ppd-base-libs';

export default defineComponent({
  name: 'NewGuide',
  components: {
  },
  setup() {
    const cacheKey = 'discount_center_home_new_guide';
    // 是否已经展示过了
    const hasAlreadyShow = function () {
      return localStorage.getItem(cacheKey) === '1';
    };
    // 从模版页面进来不展示新手引导
    const fromTplInfo = url.getUrlParam('fromTplInfo') === '1';
    const timerId = ref(0);
    // 记录已经展示过
    const saveShowNewGuideCache = function () {
      localStorage.setItem(cacheKey, '1');
    };

    const { driverInit } = useDriver();

    onMounted(async () => {
      await abtInit();
      if (isShowNewGuide() && !hasAlreadyShow() && !fromTplInfo) {
        timerId.value = setTimeout(() => {
          driverInit();
          biBrow('new-guide.page_brow');
        }, 3000);
        saveShowNewGuideCache();
      }
    });

    onUnmounted(() => {
      clearTimeout(timerId.value);
    });

    return {
    };
  },
});
